import { render } from "./workflows.html?vue&type=template&id=514be95a&external"
import script from "./workflows.js?vue&type=script&lang=js&external"
export * from "./workflows.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__